import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  InputNumber,
  Button,
  message,
  Radio,
  Select,
  Tag,
  Space,
  Checkbox,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "@/axios/axiosInstance";
import UploadAgreement from "@/components/UploadAgreement";
import "./index.scss";
const { Option } = Select;

const PublishVideo = () => {
  const navigate = useNavigate(); // 获取 navigate 函数
  const [form] = Form.useForm();
  const [agreeToUpload, setAgreeToUpload] = useState(true); // 默认勾选

  const [selectedValue, setSelectedValue] = useState("1");
  const [systems, setSystems] = useState([
    {
      id: "Windows",
      name: "Windows",
      images: [
        "2022 数据中心版 64位中文版",
        "2022 数据中心版 64位中文UEFI版",
        "2022 数据中心版 64位英文版",
        "2022 数据中心版 64位英文UEFI版",
        "2022 with Container 数据中心版 64位中文版",
        "2022 with Container 数据中心版 64位英文版",
        "2019 数据中心版 64位中文版",
        "2019 数据中心版 64位英文版",
        "2019 with Container 数据中心版 64位中文版",
        "2019 with Container 数据中心版 64位英文版",
        "2016 数据中心版 64位中文版",
        "2016 数据中心版 64位英文版",
        "2012 R2 数据中心版 64位中文版",
        "2012 R2 数据中心版 64位英文版",
        "2022 数据中心版 64位中文版（不含图形化桌面）",
        "2022 数据中心版 64位英文版（不含图形化桌面）",
        "Version 2022 with Container 数据中心版 64位中文版（不含图形化桌面）",
        "Version 2022 with Container 数据中心版 64位英文版（不含图形化桌面）",
        "2008 R2 企业版 64位中文版",
        "2008 R2 企业版 64位英文版",
        "Version 2004 数据中心版 64位中文版（不含图形化桌面）",
        "Version 2004 数据中心版 64位英文版（不含图形化桌面）",
        "Version 2004 with Container 数据中心版 64位中文版（不含图形化桌面）",
        "Version 2004 with Container 数据中心版 64位英文版（不含图形化桌面）",
      ],
    },
    {
      id: "Linux",
      name: "Linux",
      images: [
        "3.2104 LTS 64位",
        "2.1903 LTS 64位",
        "3.2104 LTS 64位 快速启动版",
        "3.2104 LTS 等保2.0三级版",
        "2.1903 LTS 64位 快速启动版",
        "2.1903 LTS 64位 等保2.0三级版",
        "3.2104 LTS 64位 UEFI版",
        "2.1903 LTS 64位 UEFI版",
        "3.2104 LTS 64位 SCC版",
        "2.1903 LTS 64位 SCC版",
      ],
    },
    {
      id: "Ubuntu",
      name: "Ubuntu",
      images: [
        "22.04 64位 UEFI版",
        "22.04 64位",
        "20.04 64位",
        "18.04 64位",
        "16.04 64位",
        "16.04 32位",
        "14.04 64位",
        "14.04 32位",
        "20.04 64位 UEFI版",
        "18.04 64位 UEFI版",
      ],
    },
    {
      id: "CentOs",
      name: "CentOs",
      images: [
        "7.9 64位",
        "7.9 64位 UEFI版",
        "8.4 64位 SCC版",
        "8.3 64位 SCC版",
        "7.9 64位 SCC版",
        "7.8 64位",
        "7.7 64位",
        "7.6 64位",
        "7.5 64位",
        "7.4 64位",
        "7.3 64位",
        "7.2 64位",
        "6.9 64位",
        "6.8 32位",
        "6.10 64位",
        "8.5 64位 UEFI版",
        "8.4 64位 UEFI版",
        "8.3 64位 UEFI版",
        "8.5 64位 ",
        "8.4 64位 ",
        "8.3 64位 ",
        "8.2 64位 ",
        "8.1 64位 ",
        "8.0 64位 ",
      ],
    },
  ]);

  // 假设这里用于存储每个系统选中的镜像（实际应用中可能需要根据具体需求设计数据结构）
  const [selectedImages, setSelectedImages] = useState({
    Windows: "2022 数据中心版 64位中文版",
  });
  const [cpuTag, setcpuTag] = useState("1");
  const [neicTag, setneicTag] = useState("1");
  const [shiyTag, setshiycTag] = useState([{ key: "1", value: "AI绘画" }]);
  const [timeTag, settimeTag] = useState("1");
  const [syscheck, setSyscheck] = useState(false);
  const [sysName, setSysName] = useState();
  const [dataDetail, setDatali] = useState({});
  const [estimatedIncome, setEstimatedIncome] = React.useState(1);
  const handleTagClick = (tag) => {
    if (cpuTag !== tag.key) {
      setcpuTag(tag.key);
    }
  };
  const handleTNeicClick = (tag) => {
    if (neicTag !== tag.key) {
      setneicTag(tag.key);
    }
  };
  const handleShiyClick = (tag, checked) => {
    const nextSelectedTags = checked
      ? [...shiyTag, tag]
      : shiyTag.filter((t) => t.key !== tag.key);
    setshiycTag(nextSelectedTags);
  };
  const handleTimeClick = (tag) => {
    if (timeTag !== tag.key) {
      settimeTag(tag.key);
    }
  };

  let location = useLocation();
  let { state } = location;
  let itemId = state?.id;
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `computPower/account/detail?computPowerId=${id}`
      );
      setDatali(response.data.data);
      setEstimatedIncome(
        response.data.data.hireTime * response.data.data.hirePrice
      );
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    if (itemId) {
      fetchDetails(itemId); // 如果itemId存在，
    }
  }, [itemId]); // 空依赖数组确保只运行一次// 空数组作为依赖项表示这个 effect 只在组件挂载时运行一次

  useEffect(() => {
    // 当dataDetail更新时，更新表单的值
    if (Object.keys(dataDetail).length > 0) {
      form.setFieldsValue({
        hireTime: dataDetail.hireTime || 1,
        hirePrice: dataDetail.hirePrice || 1,
        space: dataDetail.space || 40,
        width: dataDetail.width || 1,
        ...dataDetail,
      });

      settimeTag(dataDetail.hireType + "");
      setcpuTag(dataDetail.cpu + "");
      // memory
      setneicTag(dataDetail.memory + "");
      // setneicTag(dataDetail.graphicsMemory + "");
      let str = dataDetail.systemEnvironment;
      let parts = str.split(": "); // 使用 ': ' 作为分隔符来分割字符串
      let obj = {};
      let key = "";
      let value = "";
      if (parts.length > 1) {
        key = parts[0]; // 获取键
        value = parts[1]; // 获取值
        obj[key] = value; // 创建对象
      }
      if (key) {
        setSelectedImages(obj);
      } else {
        setSysName(str);
        setSyscheck(true);
      }

      setSelectedValue(dataDetail.width + "");
      try {
        let b = [
          { key: "1", value: "AI绘画" },
          { key: "2", value: "科学计算" },
          { key: "3", value: "渲染" },
          { key: "4", value: "模型推理" },
          { key: "5", value: "模型训练" },
        ];
        const keysArray = dataDetail.useScene.split(",");
        const filteredArray = b.filter((item) => keysArray.includes(item.key));
        const jsonData = filteredArray;
        setshiycTag(jsonData);
      } catch (e) {
        setshiycTag([{ key: "1", value: "AI绘画" }]);
      }
    }
  }, [dataDetail, form]); // 依赖dataDetail和form，以便在它们变化时重新运行
  const onFinish = (values) => {
    const formData = new FormData();
    let systemEnvironment = syscheck
      ? sysName
      : Object.keys(selectedImages)
          .map((key) => `${key}: ${selectedImages[key]}`)
          .join("");
    let url = "/computPower/account/save";

    if (itemId) {
      formData.append("computPowerIdArray", itemId);
      url = "/computPower/account/update";
    }
    let a = shiyTag.map((item) => item.key).join(",");
    formData.append("gpu", values.gpu);
    formData.append("cpu", cpuTag);
    formData.append("graphicsMemory", values.graphicsMemory);
    formData.append("memory", neicTag);
    formData.append("width", values.width);
    formData.append("space", values.space);
    // formData.append('syscheck', syscheck);
    formData.append("systemEnvironment", systemEnvironment);
    formData.append("area", values.area);
    formData.append("useScene", a);
    formData.append("hireType", timeTag);
    formData.append("hireTime", values.hireTime);
    formData.append("hirePrice", values.hirePrice);
    try {
      axiosInstance
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "10000") {
            message.success("保存成功");
            form.resetFields();
            navigate("/personal?selectedKey=4&openKeys=sub2&openKeys=sub1");
          } else {
            message.error("保存失败");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {};

  const formItemLayout = {
    labelCol: {
      xs: { span: 20 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    },
  };

  const shiyOptions = [
    { key: "1", value: "AI绘画" },
    { key: "2", value: "科学计算 " },
    { key: "3", value: "渲染" },
    { key: "4", value: "模型推理" },
    { key: "5", value: "模型训练" },
  ].map((tag) => (
    <Tag.CheckableTag
      color={"blue"}
      key={tag.key}
      checked={shiyTag.find((v) => v.key == tag.key)}
      onChange={(checked) => handleShiyClick(tag, checked)}
      className="tag-shiy"
    >
      {tag.value}
    </Tag.CheckableTag>
  ));
  const timeOptions = [
    { key: "1", value: "按天" },
    { key: "2", value: "按月 " },
    { key: "3", value: "按年" },
  ].map((tag) => (
    <Tag
      color={timeTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTimeClick(tag)}
      className="tag-time"
    >
      {tag.value}
    </Tag>
  ));

  const cputagOptions = [
    { key: "1", value: "1核(vCPU)" },
    { key: "2", value: "2核(vCPU) " },
    { key: "3", value: "4核(vCPU)" },
    { key: "4", value: "8核(vCPU)" },
    { key: "5", value: "16核(vCPU)" },
    { key: "6", value: "32核(vCPU)" },
    { key: "7", value: "48核(vCPU)" },
  ].map((tag) => (
    <Tag
      color={cpuTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const neitagOptions = [
    { key: "1", value: "2GiB" },
    { key: "2", value: "4GiB " },
    { key: "3", value: "8GiB" },
    { key: "4", value: "16GiB" },
    { key: "5", value: "32GiB" },
    { key: "6", value: "64GiB" },
    { key: "7", value: "128GiB" },
    { key: "8", value: "256GiB" },
    { key: "9", value: "512GiB" },
  ].map((tag) => (
    <Tag
      color={neicTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTNeicClick(tag)}
    >
      {tag.value}
    </Tag>
  ));

  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
    form.setFieldsValue({ width: e.target.value });
  };

  const handleInputChange = (value) => {
    setSelectedValue(value);
    form.setFieldsValue({ width: value });
  };

  const handleIncrement = () => {
    const newValue = selectedValue ? parseInt(selectedValue, 10) + 1 : 1;
    setSelectedValue(newValue);
    form.setFieldsValue({ width: newValue });
  };

  const handleDecrement = () => {
    if (selectedValue && parseInt(selectedValue, 10) > 0) {
      const newValue = parseInt(selectedValue, 10) - 1;
      setSelectedValue(newValue);
      form.setFieldsValue({ width: newValue });
    }
  };
  const handleImageChange = (systemId, value) => {
    // 更新选中镜像的状态
    setSelectedImages((prev) => ({
      // ...prev,
      [systemId]: value,
    }));
    setSyscheck(false);
    setSysName();
  };
  const allProvinces = [
    { value: "北京市", label: "北京市" },
    { value: "天津市", label: "天津市" },
    { value: "上海市", label: "上海市" },
    { value: "重庆市", label: "重庆市" },
    { value: "河北省", label: "河北省" },
    { value: "山西省", label: "山西省" },
    { value: "辽宁省", label: "辽宁省" },
    { value: "吉林省", label: "吉林省" },
    { value: "黑龙江省", label: "黑龙江省" },
    { value: "江苏省", label: "江苏省" },
    { value: "浙江省", label: "浙江省" },
    { value: "安徽省", label: "安徽省" },
    { value: "福建省", label: "福建省" },
    { value: "江西省", label: "江西省" },
    { value: "山东省", label: "山东省" },
    { value: "河南省", label: "河南省" },
    { value: "湖北省", label: "湖北省" },
    { value: "湖南省", label: "湖南省" },
    { value: "广东省", label: "广东省" },
    { value: "海南省", label: "海南省" },
    { value: "四川省", label: "四川省" },
    { value: "贵州省", label: "贵州省" },
    { value: "云南省", label: "云南省" },
    { value: "陕西省", label: "陕西省" },
    { value: "甘肃省", label: "甘肃省" },
    { value: "青海省", label: "青海省" },
    // { value: '台湾省', label: '台湾省' }, // 注意：实际情况中，这里可能需要特殊处理或敏感处理
    { value: "内蒙古自治区", label: "内蒙古自治区" },
    { value: "广西壮族自治区", label: "广西壮族自治区" },
    { value: "西藏自治区", label: "西藏自治区" },
    { value: "宁夏回族自治区", label: "宁夏回族自治区" },
    { value: "新疆维吾尔自治区", label: "新疆维吾尔自治区" },
    { value: "香港特别行政区", label: "香港特别行政区" },
    { value: "澳门特别行政区", label: "澳门特别行政区" },
  ];
  const initialValues = {
    hireTime: 1,
    hirePrice: 1,
    space: 40,
    width: 1,
    ...dataDetail,
  };
  const onChangeSys = (a, b) => {
    setSyscheck(a.target.checked);
    if (a.target.checked) {
      setSelectedImages({});
    }
  };
  const changeNamw = (v) => {
    setSysName(v.target.value);
  };
  const onReset = () => {
    form.resetFields();
    navigate("/personal?selectedKey=4&openKeys=sub2&openKeys=sub1");
  };
  // 监听表单值的变化
  const onValuesChange = (changedValues, allValues) => {
    // 这里可以获取到hireTime和hirePrice的当前值
    const hireTime = allValues.hireTime;
    const hirePrice = allValues.hirePrice;

    setEstimatedIncome(hireTime * hirePrice);
    //   }
  };
  return (
    <Form
      form={form}
      {...formItemLayout}
      name="sys_form"
      onFinish={onFinish}
      initialValues={initialValues} // 设置初始值
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      onValuesChange={onValuesChange}
    >
      {/*<h2>主机配置</h2>*/}
      <Form.Item
        label="GPU型号"
        name="gpu"
        rules={[{ required: true, message: "请输入GPU型号!" }]}
      >
        <Input showCount maxLength={20} style={{ width: "300px" }} />
      </Form.Item>
      <Form.Item
        label="显存（GB）"
        name="graphicsMemory"
        rules={[{ required: true, message: "请输入容量" }]}
      >
        <InputNumber min={1} max={10000} />
      </Form.Item>
      <Form.Item label="CPU" name="cpu">
        <div>{cputagOptions}</div>
      </Form.Item>
      <Form.Item label="内存" name="graphicsMemory">
        <div>{neitagOptions}</div>
      </Form.Item>
      <Form.Item
        name="width"
        label="宽带值（Mbps）"
        rules={[{ required: false, message: "请选择宽带值!" }]}
      >
        <Radio.Group onChange={handleRadioChange} value={selectedValue}>
          <Radio.Button value="1">1</Radio.Button>
          <Radio.Button value="20">20</Radio.Button>
          <Radio.Button value="100">100</Radio.Button>
          <Radio.Button value="500">500</Radio.Button>
          <Radio.Button value="1000">1000</Radio.Button>
          <Radio.Button value="2000">2000</Radio.Button>
          <Radio.Button value="5000">5000</Radio.Button>
        </Radio.Group>
        <div className="widthIpt">
          <div>
            <Button
              onClick={handleDecrement}
              disabled={!selectedValue || parseInt(selectedValue, 10) <= 0}
            >
              -
            </Button>
            <InputNumber
              min={1}
              value={selectedValue || undefined}
              onChange={handleInputChange}
            />
            <Button onClick={handleIncrement}>+</Button>
          </div>
        </div>
      </Form.Item>
      <Form.Item
        label="容量（GB）"
        name="space"
        rules={[{ required: true, message: "请输入容量" }]}
      >
        <InputNumber min={1} max={100000} />
      </Form.Item>
      <Form.Item
        label="系统环境"
        name={"12"} // 假设你想在表单数据中按这种方式存储镜像ID
        rules={[{ required: false }]}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <div>
            {systems.map((system) => {
              let pName = selectedImages.hasOwnProperty(system.id)
                ? system.id + "-show"
                : system.id;
              let url = require(`./img/${pName}.png`);
              return (
                <div
                  key={system.id}
                  className={`system ${
                    selectedImages.hasOwnProperty(system.id)
                      ? "sys-blue"
                      : "sys-b"
                  }`}
                >
                  <div className="sysName">
                    <img src={url} alt="Logo" /> {system.name}
                  </div>
                  <Select
                    placeholder="请选择镜像"
                    value={selectedImages[system.id] || undefined} // 设置初始值
                    onChange={(value) => handleImageChange(system.id, value)}
                  >
                    {system.images.map((image) => (
                      <Option key={image} value={image}>
                        {image}
                      </Option>
                    ))}
                  </Select>
                </div>
              );
            })}
          </div>

          <div>
            <Checkbox checked={syscheck} onChange={(a, b) => onChangeSys(a, b)}>
              <Input
                placeholder="请输入其他版本"
                style={{ width: "200px" }}
                value={sysName}
                onChange={(v) => changeNamw(v)}
              />
            </Checkbox>
          </div>
        </Space>
      </Form.Item>
      <Form.Item
        name="area"
        label="所在地区"
        rules={[{ required: true, message: "请选择省份!" }]} // 验证规则，这里要求必须选择
      >
        <Select placeholder="请选择省份" style={{ width: "150px" }}>
          {allProvinces.map((province) => (
            <Select.Option key={province.value} value={province.value}>
              {province.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="适用场景"
        name="useScene"
        rules={[{ required: false, message: "请选择适用场景" }]}
      >
        <div>{shiyOptions}</div>
      </Form.Item>
      <Form.Item
        label="出租类型"
        name="hireType"
        rules={[{ required: false, message: "请选择出租类型" }]}
      >
        <div>
          <div
            direction="vertical"
            style={{ width: "100%" }}
            className="chuzsz"
          >
            {timeOptions}
          </div>
        </div>
      </Form.Item>
      <Form.Item
        label="出租时长"
        name="hireTime"
        rules={[{ required: true, message: "请选择出租时长" }]}
      >
        <InputNumber min={1} max={200} />
      </Form.Item>
      <Form.Item
        label={`出租价格（元 / ${
          timeTag == "1" ? "天" : timeTag == "2" ? "月" : "年"
        }）`}
        name="hirePrice"
        rules={[{ required: true, message: "请输入出租价格" }]}
      >
        <InputNumber min={1} max={9999999} />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <div>
          资源预计收入： <span className="allMoney">￥{estimatedIncome}</span>
        </div>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <UploadAgreement checked={agreeToUpload} onChange={setAgreeToUpload} />
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: "40px" }}
        >
          提交
        </Button>
        <Button htmlType="button" onClick={onReset}>
          取消
        </Button>
      </Form.Item>
    </Form>
  );
};
export default PublishVideo;
